module.exports = __webpack_public_path__ + "img/relvado_en.86e4e2d7.jpg";